<script>
  import Vue from 'vue'
  import Store from '../store'
  import EventBus from '../eventbus'
  import EventListener from '../eventlistener'
  import enquire from 'enquire.js'
  import { breakpoints } from '../config.js'
  import { isIOS } from '../helpers.js'
  // headroom is the initialised instance of Headroom
  // headroomTolerance is an object of constants
  import headroom, { headroomTolerance } from '../init-headroom.js'
  import FixedFocus from '../directives/FixedFocus.js'

  export default {
    name: 'bigsearch',
    template: '#BigsearchTemplate',
    directives: {
      FixedFocus
    },
    mounted() {
      this.timer = 0
      EventListener.showSearchListener(this.show)
      EventListener.hideSearchListener(this.hide)

      // close search if open when screen changes to palm size
      enquire.register(`(max-width: ${breakpoints.maxpalm})`, {
        match: this.hide
      })
    },
    updated() {
      if (this.searchShown) {
        this.$nextTick(() => this.$el.querySelector('.s').focus())
      }
    },
    computed: {
      searchShown() { return Store.searchShown },

      searchTerm: {
        get() { return Store.searchTerm },
        set(term) {
          Store.searchTerm = term
        }
      },

      iOS() {
        return isIOS
      }
    },
    methods: {
      hideSearch() {
        this.$nextTick(() => (this.lostFocus()) ? EventBus.$emit('hideSearch') : false)
      },

      lostFocus() {
        return !document.activeElement.closest('#Bigsearch')
      },

      hide() {
        Store.searchShown = false
        // reset headroom tolerance to non-iPhone-workaround value
        this.timer = setTimeout(() => headroom.tolerance = headroomTolerance.lap, 10)
      },

      show() {
        clearTimeout(this.timer)
        if (!window.matchMedia(`(min-width: ${breakpoints.lap})`).matches) {
          headroom.tolerance = headroomTolerance.small
        }
        Store.searchShown = true
      },
    },
  }
</script>



// WEBPACK FOOTER //
// sportspower/assets/es6/components/Bigsearch.vue